"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DPayPriceCacheToJSON = exports.DPayPriceCacheFromJSONTyped = exports.DPayPriceCacheFromJSON = void 0;
function DPayPriceCacheFromJSON(json) {
    return DPayPriceCacheFromJSONTyped(json, false);
}
exports.DPayPriceCacheFromJSON = DPayPriceCacheFromJSON;
function DPayPriceCacheFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'expiresAt': json['expiresAt'],
        'price': json['price'],
    };
}
exports.DPayPriceCacheFromJSONTyped = DPayPriceCacheFromJSONTyped;
function DPayPriceCacheToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
        'expiresAt': value.expiresAt,
        'price': value.price,
    };
}
exports.DPayPriceCacheToJSON = DPayPriceCacheToJSON;
